import { Form, Field } from '~/components';
import React from 'react';
import { ControlWithText } from '../CSVImportPage';
import styled from 'styled-components';
import { colors, weights } from '~/styles';

const SelectorTitle = styled.div`
  display: flex;
  flex: 1;
  font-size: 0.875rem;
  margin: 1rem;
  max-width: 10rem;
`;

const Separater = styled.hr`
  margin-top: 1rem;
`;

export function SelectImportTypeSection(isAdmin, handleTypeSelected) {
  return (
    <Form.Section title="Step 1: Select type" subtitle="Select the type of data you'd like to import.">
      <ControlWithText>
        <span>Importing CSV data for </span>
        {isAdmin && (
          <Field.SingleSelect
            onChange={handleTypeSelected}
            name="selectedDataType"
            placeholder="Select data type"
            materialPlaceholder={false}>
            <option value="members">
              <VersionLabel version={1} /> Workspace Members
            </option>

            <option value="clients">
              <VersionLabel version={1} /> Clients
            </option>

            <option value="contacts">
              <VersionLabel version={1} /> Contacts
            </option>

            <option value="projects">
              <VersionLabel version={2} /> Projects
            </option>

            <option value="time">
              <VersionLabel version={1} /> Time Entries
            </option>

            <option value="expenseItems">
              <VersionLabel version={2} /> Expenses
            </option>

            <option value="projectLedger">
              <VersionLabel version={2} /> Project Ledgers
            </option>

            <option value="allocations">
              <VersionLabel version={2} /> Allocations
            </option>

            <option value="projectRoles">
              <VersionLabel version={2} /> Project Roles
            </option>

            <option value="projectTasks">
              <VersionLabel version={2} /> Project Tasks
            </option>

            <option value="costs">
              <VersionLabel version={2} /> Member Costs
            </option>

            <option value="memberSkillAssignments">
              <VersionLabel version={2} /> Member Skill Assignments
            </option>

            <Separater />

            <SelectorTitle>Ruddr Admin Only</SelectorTitle>

            <option value="projectTags">
              <VersionLabel version={1} /> Project Tags
            </option>

            <option value="projectTaskTags">
              <VersionLabel version={1} /> Project Task Tags
            </option>
            <option value="projectTaskRoleMember">
              <VersionLabel version={1} /> Project Task Assignments
            </option>
            <option value="projectAssignments">
              <VersionLabel version={2} /> Project Member Assignments
            </option>
            <option value="memberTags">
              <VersionLabel version={1} /> Member Tags
            </option>

            <option value="targets">
              <VersionLabel version={1} /> Member Target Util Periods
            </option>

            <option value="availability">
              <VersionLabel version={1} /> Member Availability Period
            </option>

            <option value="invoices">
              <VersionLabel version={2} /> Invoices
            </option>

            <option value="invoiceLines">
              <VersionLabel version={2} /> Invoice Lines
            </option>

            <option value="timesheets">
              <VersionLabel version={1} /> Generate Timesheets
            </option>
          </Field.SingleSelect>
        )}
        {!isAdmin && (
          <Field.SingleSelect
            onChange={handleTypeSelected}
            name="selectedDataType"
            placeholder="Select data type"
            materialPlaceholder={false}>
            <option value="members">Workspace Members</option>
            <option value="clients">Clients</option>
            <option value="contacts">Contacts</option>
            <option value="projects">Projects</option>
            <option value="time">Time Entries</option>
            <option value="expenseItems">Expenses</option>
            <option value="projectRoles">Project Roles</option>
            <option value="projectTasks">Project Tasks</option>
            <option value="projectLedger">Project Ledgers</option>
            <option value="allocations">Allocations</option>
            <option value="costs">Member Costs</option>
            <option value="memberSkillAssignments">Member Skill Assignments</option>
          </Field.SingleSelect>
        )}
      </ControlWithText>
    </Form.Section>
  );
}

const Badge = styled.div`
  display: inline-block;
  margin-right: 0.25rem;

  padding: 0.125rem 0.5rem;

  background-color: ${({ v }) => (v === 2 ? colors.primary10 : colors.grey5)};

  color: ${({ v }) => (v === 2 ? colors.accent : colors.black)};

  font-size: 0.6875rem;
  font-weight: ${weights.bold};

  border-radius: 9999px;
  vertical-align: middle;
  white-space: nowrap;
`;

export function VersionLabel({ version }) {
  if (!version) return null;

  return <Badge v={Number(version)}>{`v${version}`}</Badge>;
}
